import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MelbourneIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_1158_10803)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.2124 17.0663C11.2099 17.2981 11.1144 17.5177 10.9443 17.6825C10.7743 17.8473 10.542 17.9455 10.2922 17.9582C10.1804 17.9665 10.0673 17.9586 9.95688 17.9348C9.76824 17.8923 9.5947 17.8011 9.45673 17.6721C9.31875 17.5431 9.2221 17.3817 9.17815 17.2067L8.53221 14.8285L11.2963 14.236L11.2124 17.0663Z",
                        fill: "#00C875",
                        stroke: "#00CA72",
                        strokeWidth: "0.546204"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.5975 6.43575L13.5062 7.5724C12.8761 7.91577 12.3433 8.41962 11.9601 9.03435C11.577 9.64907 11.3567 10.3535 11.321 11.0782L11.2368 12.8289L11.181 12.84L8.33105 13.5754L7.60957 10.3895C7.46681 9.75927 7.44914 9.10524 7.55762 8.46572C7.66609 7.82619 7.89852 7.21403 8.2413 6.66507C8.58408 6.11611 9.03032 5.6414 9.55389 5.26871C10.0775 4.89603 10.6678 4.63288 11.2904 4.49466L14.5388 3.76632L15.5975 6.43575Z",
                        fill: "#00C875",
                        stroke: "#00CA72",
                        strokeWidth: "0.546204"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M18.788 4.86554L16.836 5.87666L15.8475 3.52022L18.1091 3.05338C18.3429 3.00505 18.5872 3.04167 18.797 3.15647C19.0067 3.27127 19.1678 3.45651 19.2504 3.67798C19.3329 3.89945 19.3315 4.14221 19.2463 4.36143C19.1611 4.58065 18.9979 4.76154 18.7868 4.8707L18.788 4.86554Z",
                        fill: "#00C875",
                        stroke: "#00CA72",
                        strokeWidth: "0.546204"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.10039 7.98313L1.23365 7.1219C1.14042 7.10114 1.05994 7.0411 1.00992 6.955C0.959907 6.8689 0.944446 6.76379 0.966941 6.6628C0.989436 6.5618 1.04804 6.47319 1.12987 6.41645C1.2117 6.35972 1.31005 6.33951 1.40328 6.36028L5.27003 7.2215C5.36326 7.24226 5.44373 7.3023 5.49375 7.3884C5.54376 7.4745 5.55923 7.57961 5.53673 7.68061C5.51424 7.7816 5.45563 7.87022 5.3738 7.92695C5.29197 7.98368 5.19362 8.00389 5.10039 7.98313Z",
                        fill: "#00C875",
                        stroke: "#00CA72",
                        strokeWidth: "0.546204"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.08743 4.42878L5.13257 3.99338C5.03831 3.97238 4.95684 3.91213 4.90609 3.82586C4.85534 3.7396 4.83947 3.6344 4.86196 3.5334C4.88446 3.4324 4.94348 3.34388 5.02604 3.28731C5.1086 3.23074 5.20794 3.21076 5.30221 3.23175L7.25706 3.66715C7.35133 3.68814 7.43279 3.7484 7.48354 3.83466C7.53429 3.92092 7.55017 4.02613 7.52767 4.12712C7.50518 4.22812 7.44616 4.31664 7.36359 4.37321C7.28103 4.42978 7.18169 4.44977 7.08743 4.42878Z",
                        fill: "#00C875",
                        stroke: "#00CA72",
                        strokeWidth: "0.546204"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.22122 12.8065L3.26636 12.3711C3.1721 12.3501 3.09063 12.2898 3.03988 12.2035C2.98913 12.1173 2.97325 12.0121 2.99575 11.9111C3.01824 11.8101 3.07726 11.7216 3.15983 11.665C3.24239 11.6084 3.34173 11.5884 3.43599 11.6094L5.39085 12.0448C5.48512 12.0658 5.56658 12.1261 5.61733 12.2123C5.66808 12.2986 5.68396 12.4038 5.66146 12.5048C5.63897 12.6058 5.57994 12.6943 5.49738 12.7509C5.41482 12.8075 5.31548 12.8275 5.22122 12.8065Z",
                        fill: "#00C875",
                        stroke: "#00CA72",
                        strokeWidth: "0.546204"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1158_10803",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
